module.exports = __webpack_public_path__ + "img/prosuctivity-1.29bda843.png";